<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <div class="page_title">授權選位</div>
      <div class="authorized_block">
        <div class="page_sub_title count_title">授權數量</div>
        <input type="number" @input="give_amount_input()" v-model="give_amount"/>
        <button class="btn--pill pill blue" @click="authorization()">確認送出</button>
        
        <template v-if="currentAuthorizationCodeGetter">
          <hr class="w-100"/>
          <div class="page_sub_title">請將驗證碼提供給被授權公司，被授權公司可於授權紀錄進行驗證</div>
          <div class="card d-flex flex-column align-items-center">
            <div class="title">驗證碼</div>
            <div class="verification_code">{{ currentAuthorizationCodeGetter.code || '-' }}</div>
            <div class="effective_time">認證有效時間：{{ currentAuthorizationCodeGetter.expirationTime }}止</div>
          </div>
        </template>
        
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EnterpriseAuthorizedBoothsContent',
  components: {
  },
  data () {
    return {
        give_amount: 1,
    }
  },
  computed: {
    ...mapGetters('pages/enterprises', [
      'currentAuthorizationCodeGetter',
    ]),
  },
  async created () {
  },
  methods: {
    ...mapActions('pages/enterprises', [
      'getEnterpriseBoothAuthorizationGiveById',
    ]),
    authorization() {
      this.getEnterpriseBoothAuthorizationGiveById({
        id: this.$route.params.id,
        give_amount: this.give_amount_input(),
      });
    },
    give_amount_input() {
      let temp = parseFloat((this.give_amount + '').replace(/[^\d\.-]/g, ''))
      temp = (Math.floor(temp) + '').replace(/\./g, '')
      this.give_amount = Math.max(temp, 1)
      return this.give_amount;
    },
  }
}
</script>